// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "div.resultbody {\n    margin-top: 0.25em;\n    border: 1px solid #bbb;\n    white-space: nowrap;\n    overflow: hidden;\n    background-color: white;\n    min-width: 15em;\n    display: flex;\n    align-items: center;\n}\n\ndiv.resultbody > span {\n    flex: 1 1 auto;\n    text-align: center;\n    padding: 0.25em;\n}\n\ndiv.resultbody > select {\n    flex: 0 0 auto;\n}\n", ""]);
// Exports
module.exports = exports;
